module.exports = __webpack_public_path__ + "static/media/sparq2.ece90bc7.jpg";